module.exports = __webpack_public_path__ + "static/media/6-ball.c011b0cb.png";